import { Dictionary } from '@/types/general'
import { IEntryExported } from '@/types/entry'

export type Mutator = (data: string) => IEntryExported[]

/**
 * Register and get importers based on file extensions.
 */
class MutatorFactory {
    /**
     * Mapping of file type to mutator function
     */
    private types: Dictionary<Mutator> = {}

    /**
     * Register an mutator to a file extension
     *
     * @param {string} type file extension
     * @param {Mutator} mutator mutator for type
     */
    public register(type: string, mutator: Mutator): void {
        if (this.hasMutator(type)) {
            throw new Error(`Tried to register mutator for existing type ${type}`)
        }
        this.types[type] = mutator
    }

    /**
     * Test if an mutator is registered for the file
     * type
     *
     * @param {string} type file extension
     * @returns {boolean} mutator registered
     */
    public hasMutator(type: string): boolean {
        return type in this.types
    }

    /**
     * Get an mutator for a specific type. Throws an exception if
     * the type isn't registered
     *
     * @param {string} type file extension
     * @returns {Mutator} mutator for type
     */
    public getMutator(type: string): Mutator {
        if (!this.hasMutator(type)) {
            throw new Error(`No mutator found for type ${type}`)
        }
        return this.types[type]
    }

    /**
     * Get all registered file types
     *
     * @returns {string[]} list of file extensions
     */
    public getTypes(): string[] {
        return Object.keys(this.types)
    }

    /**
     * Clear all mutators registered
     * Should only be used for testing
     */
    public clearMutators(): void {
        this.types = {}
    }
}
export default new MutatorFactory()
